<template>
  <div class="team-result">
    <ucar-title type="confirmBack">{{title}}</ucar-title>
    <div class="team-result-header">
      <h2>{{statusTitle}}</h2>
      <p>{{statusDesc}}</p>
    </div>
    <ucar-middle-header
      :list="infoList"
    ></ucar-middle-header>
    <div class="team-result-body">
      <ucar-process-flow
        :list="step"
        :current-step="currentStep"
      ></ucar-process-flow>
      <div class="team-result-submit-wrap" v-if="showBtn">
        <ucar-button v-if="status === 6" @click="activating">激活</ucar-button>
        <ucar-button v-else @click="reTry">重新报名</ucar-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getTeamRecruitStatus } from '../../api'
import { ServerTypeConverter, teamStatus } from '../../utils/enroll-status'
export default {
  data () {
    return {
      title: '神州专车车队招募',
      infoList: [],
      status: 0,
      step: [],
      currentStep: 0,
      statusTitle: '',
      statusDesc: ''
    }
  },
  computed: {
    showBtn () {
      return [6, 11, 12, 13, 15, 17].indexOf(this.status) !== -1
    }
  },
  methods: {
    init (id) {
      getTeamRecruitStatus(id)
        .then(res => {
          this.statusTitle = res.processTitle
          this.statusDesc = res.processDesc
          this.status = res.currentStatus
          this.infoList = [
            {
              key: '企业名称',
              value: res.companyName
            },
            {
              key: '联系人姓名',
              value: res.contactName
            },
            {
              key: '联系人手机号',
              value: res.contactPhone
            }
          ]
          const statusEnum = ServerTypeConverter.team
          if (!statusEnum[this.status] || !teamStatus[statusEnum[this.status]]) return
          const target = teamStatus[statusEnum[this.status]]
          this.step = target.step
          this.currentStep = target.current
        })
    },
    activating () {
      this.$router.push(`/team-activating?id=${this.vuexRecruitId}`)
    },
    reTry () {
      this.changeStatusToFillInfo()
      this.$router.push('/team-info')
    }
  },
  mounted () {
    if (this.$route.query.id) this.setVuexRecruitId(this.$route.query.id)
    this.init(this.vuexRecruitId)
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";
.team-result {
  .team-result-header {
    color: $ucar_main_color;
    background-color: $ucar_dark_bg;
    min-height: 290px;
    h2 {
      text-align: center;
      color: $ucar_main_color;
      margin: 60px 0 30px;
      padding: 0 45px;
    }
    p {
      text-align: center;
      color: $ucar_assist_color;
      margin-bottom: 30px;
      padding: 0 45px;
    }
  }
  .team-result-body {
    padding: 0 30px;
    flex: 1 0 auto;
    display: flex;
    flex-flow: nowrap column;
    .team-result-submit-wrap {
      padding: 30px 0;
      display: flex;
    }
  }
}
</style>
